module.exports = require("./../../_gen/openfl/display3D/IndexBuffer3D");